import { createSelector } from 'reselect'

import { RootState } from 'redux/store';

const stateSelector =  ({
  layout: { controller, url, deviceType: { isMobile }, pageId },
  accordion: { expandedNodeId, breadCrumbClicked },
  legislation: { actIdMap },
  placeholders: { isAccordionLoaded }
}: RootState) => {
  return { url, controller, expandedNodeId, breadCrumbClicked, isMobile, actIdMap, pageId, isAccordionLoaded }
}

const selectAccordionFoundState = createSelector(stateSelector, state => state)

export default selectAccordionFoundState
